/* eslint-disable arrow-body-style */

import _ from 'underscore';

export const getBusinessNameWithAdsStyles = ({ styleOverrides }) => () => {
  return {
    businessNameWithAds: _.extend({
      marginTop: 9,
      padding: '1px 0',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }, styleOverrides.businessNameWithAds),
  };
};
